<template>
    <div class="menu">
        <div class="menu-logo">
            <div class="logo-box">
                <img src="../assets/logo.png" alt="">
                Hạn Mức+
            </div>
            <div class="info-box">
                <img src="../assets/pel.png" alt="">
                +84 845767690
                <br>
                news@truongnguyenthinhphat.com
            </div>
            <div class="info-box">
                <img src="../assets/add.png" alt="">
                243/6 Phan Văn Hớn, Phường Tân Thới Nhất, Quận 12 TPHCM
            </div>

        </div>

        <div class="menu-box">
            <div class="item" :class="step == 1 ? 'select' : ''" @click="selectMenu(1)">TRANG CHỦ </div>
            <div class="item" :class="step == 2 ? 'select' : ''" @click="selectMenu(2)">về chúng tôi</div>
            <div class="item" :class="step == 3 ? 'select' : ''" @click="selectMenu(3)">liên hệ chúng tôi</div>
            <!-- <div class="item" :class="step == 4 ? 'select' : ''" @click="selectMenu(4)">COUNTACT</div> -->
        </div>
    </div>
</template>
<script>
export default {
    name: "Menu",
    props: {
        step: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            index: 0
        };
    },
    methods: {
        selectMenu(value) {
            this.index = value
            if (value == this.step) {
                return
            }
            switch (value) {
                case 1: this.$router.push({ path: "/" }); break;
                case 2: this.$router.push({ path: "AboutUs" }); break;
                case 3: this.$router.push({ path: "ContactUs" }); break;
                // case 4: this.$router.push({ path: "ContactUs" }); break;
                // case 5: this.$router.push({ path: "aboutUs" }); break;
                // case 5: this.$router.push({ path: "cooperate" }); break;
                default: this.$router.push({ path: "/" }); break;
            }
        }
    }
}
</script>
<style lang="less" scoped>
.menu {
    .menu-logo {
        padding: 0px 360px;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .logo-box {
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: bold;
            font-size: 18px;
            color: #0E235F;

            img {
                margin-right: 10px;
                width: 48px;
            }
        }

        .info-box {
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 400;
            font-size: 14px;
            color: #0E235F;
            width: 300px;

            img {
                margin-right: 10px;
                width: 24px;
            }
        }
    }

    .menu-box {
        display: flex;
        font-size: 18px;
        font-weight: 500;
        color: #333;
        cursor: pointer;
        padding: 0px 360px;
        background: #F6F6F6;
        height: 80px;
        line-height: 80px;

        .item {
            padding: 0px 10px;
            margin-right: 50px;
        }
    }

    .select {
        color: #3568FE;
        border-bottom: 4px solid #3568FE;
        font-weight: bolder;
    }
}
</style>